import { render, staticRenderFns } from "./add_select.vue?vue&type=template&id=a3620584&scoped=true"
import script from "./add_select.vue?vue&type=script&lang=js"
export * from "./add_select.vue?vue&type=script&lang=js"
import style0 from "./add_select.vue?vue&type=style&index=0&id=a3620584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3620584",
  null
  
)

export default component.exports